import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-change-modals',
  templateUrl: './change-modals.component.html',
  styleUrls: ['./change-modals.component.css']
})

export class ChangeModalsComponent implements OnInit {

  public id: string;
  private value;

  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  action;

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
   
  }

  ngOnInit() {
    this.setValue();
  }

  setValue() {
    this.value = (new Date(this.action.date.getTime() - (this.action.date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]);
  }

  renameGroup() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false; 
    if(this.action.id) {
      this.adminService.delWeekends(this.action.id).subscribe(
        (res: any) => {
          this.successInfo = true;
          this.errorInfo = false;
          this.disabledBtn = false;
          this.activeModal.close('ok');
        },
        () => {
          this.errorInfo = true;
        }
      );
    } else {
      this.adminService.addWeekends(this.value, 1).subscribe(
        (res: any) => {
          this.successInfo = true;
          this.errorInfo = false;
          this.disabledBtn = false;
          this.activeModal.close('ok');
        },
        () => {
          this.errorInfo = true;
        }
      );
    }
  }

  disableBtnValidation() {
    return this.value === null;
  } 

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/task-fullview-popup/change-modals/change-modals.component.ts